import { render, staticRenderFns } from "./DetailSaleOrder.vue?vue&type=template&id=69ea044c&"
import script from "./DetailSaleOrder.vue?vue&type=script&lang=js&"
export * from "./DetailSaleOrder.vue?vue&type=script&lang=js&"
import style0 from "./DetailSaleOrder.vue?vue&type=style&index=0&id=69ea044c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports